import Employment from './Employment';
import {IEmploymentProps} from "@my-pages/features/employment/types";

const UpcomingEmployment = ({ employment }: IEmploymentProps) => {
    return (
        <div className='card border border-dotted border-2 h-100'>
            <div className='card-body'>
                <div className='kicker mb-2'>KOMMANDE ARBETSGIVARE OCH ADRESS</div>
                <Employment employment={employment} />
            </div>
        </div>
    );
};

export default UpcomingEmployment;
